import AvatarGroup from "common/Avatars/AvatarGroup";
import ExchangeAvatar from "common/Avatars/ExchangeAvatar";
import { ClientToExchangeMapping } from "@shared/types";
import { CSSProperties } from "react";

interface ExchangesIconsGroupProps {
  exchanges?: string[];
  clients?: string[];
  clientToExchangeMapping?: ClientToExchangeMapping;
  size?: number;
  style?: CSSProperties;
  maxCount?: number;
}

export const ExchangesIconsGroup = ({
  exchanges,
  clients,
  clientToExchangeMapping,
  size = 32,
  style,
  maxCount = 3,
}: ExchangesIconsGroupProps) => {
  let avatarsData: { key: string; title: string; text: string }[];

  if (clients && clientToExchangeMapping) {
    avatarsData = clients
      .filter((client) => !!clientToExchangeMapping[client])
      .map((client) => ({
        key: client,
        title: client,
        text: clientToExchangeMapping[client],
      }));
  } else if (exchanges) {
    avatarsData = exchanges.map((exchange) => ({
      key: exchange,
      title: exchange,
      text: exchange,
    }));
  } else {
    return null;
  }

  return (
    <AvatarGroup
      avatarsData={avatarsData}
      maxCount={avatarsData.length === maxCount ? maxCount : maxCount - 1}
      AvatarComponent={ExchangeAvatar}
      size={size}
      style={style}
      iconSize={size - 8}
    />
  );
};
